<template>
  <div class="inner-box">
    <el-form size="mini" :model="form" ref="catInfoForm" :rules="rules">
      <el-row>
        <el-col>
          <el-col :span="12">
            <el-form-item label="품명">
              <el-input v-model="parentNm" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="규격" prop="catNm">
              <el-input v-model="form.catNm"></el-input>
              <el-input v-model="form.catId" v-show="false"></el-input>
            </el-form-item>
          </el-col>
        </el-col>
      </el-row>

    </el-form>
  </div>
</template>

<script>
export default {
  name: "BomInfo",
  props: ['bomDetail' , 'parentNm'],
  data() {
    return {
      form: {
        catKey: "",
        catNm: "",
        catId: "",
        parentId: "",
        TopKey: "",
        catIdx: "",
        description: "",
        catValue1: "",
        catValue2: "",
        catValue3: "",
        catValue4: "",
        catValue5: "",
      },
      // eslint-disable-next-line vue/no-dupe-keys
      parentNm: "",
      rules: {
        catNm: [
          { required: true, message: '분류명을 입력하세요.', trigger: 'blur' },
          { min: 3, max: 10, message: '최소 3글자 최대 10글자 입력', trigger: 'blur' }
        ],
        catKey: [
          { required: true, message: '키를 입력하세요.', trigger: 'blur' },
          { min: 1, message: '최소 1글자', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    setCatInfo() {
      Object.assign(this.form, this.catDetail, this.parentNm);
    },
  },
  watch: {
    catDetail() {
      this.setCatInfo();
    }
  }
}

</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 0;
  // &:last-child {
  //   margin-bottom: 0;
  // }
}
.el-form {
  border: 1px solid #c7c7c7;
  padding: 10px 0 0 10px;
  border-radius: 5px;
}
.el-form-item {
  margin-right: 10px;
  // &:last-child {
  //   margin-right: 0;
  // }
}
.large-textarea{
  padding: 0 24px !important
}

</style>